<template>
  <div class="">
    <div class="df df-center">
      <a-date-picker
        v-model:value="cascadeDate"
        placeholder="请选择时间"
        style="width: 160px"
      />
    </div>
    <!-- 生产任务表 -->
    <tasks-vue
      tasksType="referenceArm"
      :editAuthority="props.deleteAuthority['/product_edit_components_tasks']"
    ></tasks-vue>
    <!-- 质检信息 -->
    <quality-inspection-vue type="referenceArm" :closedLoopAuthority="props.deleteAuthority['/closedLoopAuthority']"></quality-inspection-vue>
    <!-- 异常问题统计 -->
    <abnormal-problem-vue
      type="referenceArm"
      :deleteAuthority="
        props.deleteAuthority['/product_deleteAbnormalProblemHandle']
      "
    ></abnormal-problem-vue>
    <!-- 物料缺货情况 -->
    <material-shortage
      type="referenceArm"
      :deleteAuthority="
        props.deleteAuthority['/product_deleteMaterialShortage']
      "
    ></material-shortage>
    <!-- 作业指导书及其记录表反馈 -->
    <sop
      type="referenceArm"
      :deleteAuthority="props.deleteAuthority['/product_deleteWIRecord']"
    ></sop>
    <!-- 工位检查 -->
    <station-check
      type="referenceArm"
      :deleteAuthority="props.deleteAuthority['/product_deleteStationCheck']"
    ></station-check>
    <!-- 工艺变更 -->
    <process-update
      type="referenceArm"
      :deleteAuthority="props.deleteAuthority['/product_deleteProcessChange']"
    ></process-update>
    <!-- 质量抽查 -->
    <quality-spot-check
      type="referenceArm"
      :deleteAuthority="
        props.deleteAuthority['/product_deleteQualitySpotCheck']
      "
    ></quality-spot-check>
    <!-- 质量抽查 -->
    <update-capacity-spot-check
      type="referenceArm"
      :deleteAuthority="
        props.deleteAuthority['/product_deleteCapacitySpotCheck']
      "
    ></update-capacity-spot-check>
  </div>
</template>

<script>
import { defineComponent, ref, provide } from "vue";
import moment from "moment";
import { timeStampToTime } from "@/utils/index";
// import tasksVue from "@/views/productDaily/components/product/components/tasks/index.vue";
import tasksVue from "@/views/productDaily/components/product/organizingTasks/referenceArm.vue";
import qualityInspectionVue from "@/views/productDaily/components/product/components/qualityInspection/index.vue";
import abnormalProblemVue from "@/views/productDaily/components/product/components/abnormalProblem/index.vue";
import materialShortage from "@/views/productDaily/components/product/components/materialShortage/index.vue";
import sop from "@/views/productDaily/components/product/components/sop/index.vue";
import stationCheck from "@/views/productDaily/components/product/components/stationCheck/index.vue";
import processUpdate from "@/views/productDaily/components/product/components/processUpdate/index.vue";
import qualitySpotCheck from "@/views/productDaily/components/product/components/qualitySpotCheck/index.vue";
import updateCapacitySpotCheck from "@/views/productDaily/components/product/components/updateCapacitySpotCheck";

export default defineComponent({
  props: {
    deleteAuthority: Object,
  },
  components: {
    sop,
    tasksVue,
    qualityInspectionVue,
    abnormalProblemVue,
    materialShortage,
    stationCheck,
    processUpdate,
    qualitySpotCheck,
    updateCapacitySpotCheck,
  },
  setup(props) {
    const cascadeDate = ref(
      moment(timeStampToTime("", "upload"), "YYYY-MM-DD")
    );
    provide("cascadeDate", cascadeDate);
    return {
      cascadeDate,
      props,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
